import IsIdentifiedAndTermsWrapper from './IsIdentifiedAndTermsWrapper';

export default IsIdentifiedAndTermsWrapper;
